import React, { useState, useEffect } from "react";

interface Tray {
  letter: string;
  summary: string;
  indexFile: string | null;
  imageCount: number;
}

interface Props {
  onSelectTray: (letter: string) => void;
  onLogout: () => void;
}

export function OverviewPage({ onSelectTray, onLogout }: Props) {
  const [trays, setTrays] = useState<Tray[]>([]);
  const [loading, setLoading] = useState(true);
  const [indexModal, setIndexModal] = useState<string | null>(null);

  useEffect(() => {
    fetch("/api/slides")
      .then((r) => r.json())
      .then((data) => {
        setTrays(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="loading">Dia's laden...</div>;
  }

  const totalImages = trays.reduce((sum, t) => sum + t.imageCount, 0);

  return (
    <div className="overview-page">
      <header className="overview-header">
        <h1>Familiedia's</h1>
        <div className="header-actions">
          <a
            href="/api/download/all"
            className="btn btn-download"
            title="Alles downloaden"
          >
            Alles downloaden ({totalImages} dia's)
          </a>
          <button onClick={onLogout} className="btn btn-logout">
            Uitloggen
          </button>
        </div>
      </header>

      <div className="tray-list">
        {trays.map((tray) => (
          <div
            key={tray.letter}
            className="tray-card"
            onClick={() => onSelectTray(tray.letter)}
          >
            <div className="tray-letter">{tray.letter}</div>
            <div className="tray-info">
              <div className="tray-summary">
                {tray.summary || "Geen beschrijving"}
              </div>
              <div className="tray-count">{tray.imageCount} dia's</div>
            </div>
            <div className="tray-actions" onClick={(e) => e.stopPropagation()}>
              {tray.indexFile && (
                <button
                  className="btn-icon"
                  title="Index-foto bekijken"
                  onClick={() => setIndexModal(tray.letter)}
                >
                  &#128196;
                </button>
              )}
              <a
                href={`/api/download/${tray.letter}`}
                className="btn-icon"
                title={`Slee ${tray.letter} downloaden`}
              >
                &#11015;
              </a>
            </div>
          </div>
        ))}
      </div>

      {indexModal && (
        <div className="modal-overlay" onClick={() => setIndexModal(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setIndexModal(null)}
            >
              &times;
            </button>
            <h2>Index {indexModal}</h2>
            <img
              src={`/api/slides/${indexModal}/index-photo`}
              alt={`Index ${indexModal}`}
              className="index-photo"
            />
          </div>
        </div>
      )}
    </div>
  );
}
